// extracted by mini-css-extract-plugin
export default {"container":"email_container__Pj3rm","text":"email_text__P+wtj","title":"email_title__Mph85","form":"email_form__FBoUm"};